const state = {
	clientVersion: '',
	needUpdate: false
};

const getters = {
	getClientVersion: (state) => state.clientVersion,
	isUpdateNeeded: (state) => state.needUpdate
};

const mutations = {
	updVersionStates(state, { version, needUpdate }) {
		state.clientVersion = version;
		state.needUpdate = needUpdate;
	},
	resetVersionStates(state) {
		state.clientVersion = '';
		state.needUpdate = false;
	}
};

const actions = {
	setNewVersionStates({ commit }, statesPayload) {
		commit('updVersionStates', statesPayload);
	},
	setOriginalVersionStates({ commit }) {
		commit('resetVersionStates');
	}
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
